const mediaItems = [
  {
    title: '顶流带货主播翻车全记录：从爆火到塌房只用了三个月',
    desc: '一段直播回放如何揭开网红黑料冰山一角，品牌方连夜解约始末',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20studio%20scene%20with%20empty%20live%20streaming%20setup%2C%20broken%20ring%20light%2C%20scattered%20products%20on%20floor%2C%20crimson%20ambient%20lighting%2C%20atmospheric%20cinematic%20photography%2C%20brooding%20mood%2C%20abstract%20concept%20of%20fallen%20influencer&width=600&height=400&seq=media-01&orientation=landscape',
    tag: '实锤曝光',
    views: '28.5w',
  },
  {
    title: '美妆博主代工厂深度调查：你买的"自主研发"究竟是什么',
    desc: '深入工厂暗访揭秘网红美妆品牌背后的真相，贴牌代工产业链大起底',
    img: 'https://readdy.ai/api/search-image?query=Dark%20industrial%20factory%20interior%20with%20cosmetic%20production%20line%2C%20dim%20lighting%2C%20unlabeled%20bottles%20and%20packaging%20materials%2C%20mysterious%20atmosphere%2C%20investigative%20journalism%20style%2C%20high%20contrast%20shadows%2C%20conceptual&width=600&height=400&seq=media-02&orientation=landscape',
    tag: '深度扒皮',
    views: '22.1w',
  },
  {
    title: '头部网红人设崩塌时间线梳理：一条朋友圈引发的连锁反应',
    desc: '从第一条爆料到全网震动，48小时内千万粉大号如何一步步走向深渊',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%2C%20cascading%20domino%20pieces%20in%20dark%20crimson%20and%20charcoal%20tones%2C%20metaphorical%20representation%20of%20reputation%20collapse%2C%20cinematic%20lighting%2C%20tense%20atmosphere%2C%20conceptual%20fine%20art&width=600&height=400&seq=media-03&orientation=landscape',
    tag: '时间线',
    views: '31.2w',
  },
  {
    title: '网红圈合同陷阱大揭秘：你以为的千万签约，其实是天价卖身契',
    desc: '多位经纪人匿名爆料行业内幕，霸王条款、竞业限制、天价违约金全解析',
    img: 'https://readdy.ai/api/search-image?query=Dark%20closeup%20of%20crumpled%20contract%20papers%20with%20red%20pen%20marks%2C%20dramatic%20side%20lighting%2C%20mysterious%20atmosphere%2C%20legal%20document%20concept%2C%20high%20contrast%2C%20cinematic%20photography%2C%20brooding%20mood&width=600&height=400&seq=media-04&orientation=landscape',
    tag: '业内揭秘',
    views: '19.8w',
  },
  {
    title: '情感网红"深情"人设的B面：粉丝群私密聊天记录流出',
    desc: '表面宠粉背地套路，当情感导师变成情感骗子，多位受害者联合发声',
    img: 'https://readdy.ai/api/search-image?query=Dark%20shadowy%20figure%20silhouette%20behind%20frosted%20glass%2C%20cracked%20smartphone%20screen%2C%20fragmented%20text%20messages%20abstract%2C%20crimson%20glow%2C%20mysterious%20and%20foreboding%20atmosphere%2C%20cinematic%20noir%20style&width=600&height=400&seq=media-05&orientation=landscape',
    tag: '私密曝光',
    views: '35.6w',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">黑料实况</h2>
            <p className="mt-2 text-sm text-foreground-500">精选网红黑料深度报道，每一个都有图有真相</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.slice(0, 3).map((item, idx) => (
              <div
                key={idx}
                className="group cursor-pointer rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 transition-all duration-300 hover:border-primary-500/30"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-primary-500/85 text-background-50 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3 flex items-center gap-1.5">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/80 text-foreground-700">
                      <i className="ri-play-fill text-sm"></i>
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-400 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </span>
                    {item.views} 阅读
                  </div>
                </div>
              </div>
            ))}

            {mediaItems.slice(3).map((item, idx) => (
              <div
                key={idx + 3}
                className="group cursor-pointer rounded-xl overflow-hidden bg-background-200/70 border border-background-300/40 transition-all duration-300 hover:border-primary-500/30 sm:col-span-2 lg:col-span-2"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2">
                  <div className="relative aspect-video sm:aspect-auto overflow-hidden">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-accent-500/85 text-background-50 whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-5 flex flex-col justify-center">
                    <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-400 transition-colors duration-200">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                    <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-eye-line text-xs"></i>
                      </span>
                      {item.views} 阅读
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}